import { Component, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Router, ActivatedRoute } from '@angular/router';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';
import { MessageListItem } from '../../models/application';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { UserService } from '../../services/user.service';
import { CompanyService } from '../../services/company.service';
import { VerifyService } from '../../services/verify.service';
import { UserInformation } from '../../models/registration';
import { ContactEmailInformation } from '../../models/contact';
import { CompanyInformation } from '../../models/company';
import { LogonUserInformation } from '../../models/user';;
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-multifactor-verify',
    templateUrl: './multifactor-verify.component.html',
    styleUrls: ['./multifactor-verify.component.scss']
})

export class MultifactorVerifyComponent implements OnInit {

    private _handleError: HandleError;
    private _logging = environment.logging;
    fieldValidations = environment.fieldValidations;

    recaptchaSiteKey = environment.restAPI.recaptchaSiteKey;

    showSpinner = false;

    userInformation: UserInformation;

    showInstructionMessagesSpinner = false;
    showActivitySpinner = false;
    instructionMessageList: MessageListItem[] = [];


    showVerificationFormView = false;
    showVerifyCodeButton = true;
    showSendVerifyCodeButton = true;
    showTemporaryPasswordError = false;
    showExpiredVerificationCodeError = false;
    showVerificationGracePeriodView = false;

    homeEmail: string = '';
    skipTraceCode: string = '';

    companyInformation: CompanyInformation = null;
    companyInformationFound = false;

    contactEmailInformation: ContactEmailInformation = null;
    contactEmailInformationFound = false;

    multifactorVerifyForm: FormGroup;
    userNameFormControl = new FormControl();
    verificationCodeFormControl = new FormControl();
    recaptchaFormControl = new FormControl();

    isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

    logonUserInformation!: LogonUserInformation | null;
    private subscription!: Subscription;

    constructor(
        private _route: ActivatedRoute,
        private _router: Router,
        private _formBuilder: FormBuilder,
        private _errorHandler: ErrorHandler,
        public media: MediaObserver,
        private _userService: UserService,
        private _companyService: CompanyService,
        private _verifyService: VerifyService
    ) {
        this._handleError = _errorHandler.createHandleError('MultifactorverifyComponent');
        this.getData();
        this.scrollToTop();
    }

    ngOnInit() {
        this.createForm();
        this.subscription = this._userService.logonUserInfo$                    //01/19/2026 RA - Get Logon User Information from User Service
          .subscribe(info => {
            if (!info) {
            this._router.navigate(['/login']);
            return;
          }
          this.logonUserInformation = info;
        });
    }

    ngOnDestroy(): void {
      this.subscription.unsubscribe();                                        //01/19/2026 RA - Unsubscribe to prevent memory leaks
    }

    createForm(): void {
        this.multifactorVerifyForm = new FormGroup(
            {
                userNameFormControl: this.userNameFormControl,
                verificationCodeFormControl: this.verificationCodeFormControl,
                recaptchaFormControl: this.recaptchaFormControl
            }
        );
    }

    getData(): void {

        this.companyInformation = this._companyService.getNewCompanyInformation();

        this._companyService.companyInformation.subscribe(
          response => this.onCompanyInformationChanged(response),
          error => this._handleError('companyInformation.subscribe', error)
        );

        this.getContactEmailInformation(this._verifyService.getParticipantId());

    }

    setView(showVerification:boolean): void {

        if (showVerification) {
            this.showVerificationFormView = true
            this.showVerificationGracePeriodView = false;
        } else {
            this.showVerificationGracePeriodView = true;
            this.showVerificationFormView = false
        }
    }

    isEmailValid(): boolean {
        let retval: boolean = true;

        if (this.skipTraceCode == "IN") {
            retval = false;
        }

        return retval;
    }

    getContactEmailInformation(participantId: number): void {
        if (participantId !== null) {
            this.showSpinner = true;
            this.contactEmailInformationFound = false;
            this._verifyService.getMfaContactEmailInformation().subscribe(
                result => {
                    this.contactEmailInformationFound = result !== null && result.participantId !== null && result.participantId > 0;
                    this.contactEmailInformation = result;

                    if (this._logging.serviceCallTraceLog) {
                        console.log('ContactUsComponent.getContactEmailInformation :: result.homeEmail = ' + result.homeEmail);
                    }
                    if (this._logging.serviceDataTraceLog) {
                        console.log('ContactUsComponent.getContactEmailInformation :: result = ' + JSON.stringify(result));
                    }

                    this.homeEmail = result.homeEmail;
                    this.skipTraceCode = result.skipTraceCode;
                    this._verifyService.setEmailAddress(result.homeEmail);

                    this.getDataComplete();
                },
                error => this._handleError('getContactEmailInformation', error)
            );
        } else {
            this.contactEmailInformation = {
                participantId: null,
                firstName: null,
                middleInitial: null,
                lastName: null,
                homeEmail: null,
                skipTraceCode: null
            };
            this.contactEmailInformationFound = true;
            this.getDataComplete();
        }
    }

    getDataComplete(): void {
        if (this.contactEmailInformationFound) {
            this.showSpinner = false;

            this.createForm();
            if (this._verifyService.isInGracePeriod()) {
                this.setView(false);
            } else {
                this.setView(true);
                this.sendVerificationCode(false);
            }
        }
    }

    onCompanyInformationChanged(newCompanyInformation: CompanyInformation): void {
        this.companyInformation = newCompanyInformation;
        this.companyInformationFound =
          this.companyInformation !== null && this.companyInformation.companyName !== null && this.companyInformation.companyName.length > 0;
      }

    returnToLogin(): void {
        if (this._logging.navigationTraceLog) {
            console.log('MultifactorComponent.openLogin');
        }
        this._router.navigate(['login']);
    }

    skip(): void {
        if (this._logging.navigationTraceLog) {
            console.log('MultifactorComponent.skip');
        }
        this._verifyService.skipMultifactorEnrollment().subscribe(result => {
            this._userService.completeAuthentication(result.token, result.expiresAtUtc);
            this._verifyService.setSkipEnrollment(true);
            this._router.navigate([this.logonUserInformation.securityQuestionSetupFlag ? '' : 'securityquestion']);
        }, error => this._handleError('skipMultifactorEnrollment', error));
    }

    goToProfile(): void {
        if (this._logging.navigationTraceLog) {
            console.log('MultifactorComponent.goToProfile');
        }
        this._verifyService.skipMultifactorEnrollment().subscribe(result => {
            this._userService.completeAuthentication(result.token, result.expiresAtUtc);
            this._verifyService.setSkipEnrollment(true);
            this._router.navigate([this.logonUserInformation.securityQuestionSetupFlag ? 'profile' : 'securityquestion']);
        }, error => this._handleError('skipMultifactorEnrollment', error));
    }

    checkVerificationCode(): void {

        this.showActivitySpinner = true

        var factorCode = this.multifactorVerifyForm.get('verificationCodeFormControl').value;
        factorCode = factorCode ? factorCode.trim() : '';

        this._verifyService.checkVerificationCode(factorCode).subscribe(
            result => {
                if (this._logging.serviceCallTraceLog) {
                    console.log('MultifactorVerifyComponent.checkVerificationCode :: result2 = ' + JSON.stringify(result));
                }
                if (this._logging.serviceDataTraceLog) {
                    console.log('MultifactorVerifyComponent.checkVerificationCode :: result2 = ' + JSON.stringify(result));
                }

                this.showActivitySpinner = false
                let todayMin = 0;
                const today: Date = new Date();                                     // Get today's date.
                const targetDateString = this.logonUserInformation.lastAccessed;    // The last login date for the user as string
                const targetDate_Dt = new Date(targetDateString);                   // Convert last login date String to Date
                const createdDateString = this.logonUserInformation.createdDate;    // The creation date for the user as string
                const createdDate_Dt = new Date(createdDateString);                 // Convert creation date String to Date
                if (targetDate_Dt > createdDate_Dt) {
                    todayMin = 36001;                                               // Set to over an hour if last login date is after creation date
                }
                else {
                    todayMin = today.getMinutes() - createdDate_Dt.getMinutes();    // Get the difference in minutes between creation date and today's date
                }

                const numDays = today.getTime() - targetDate_Dt.getTime();          // Get time in milliseconds
                const diffDays2 = Math.floor(numDays / (1000 * 60 * 60 * 24));      // Convert milliseconds to days and round down to nearest day.

                if (result.userId > 0) {
                    this._verifyService.setMultifactorEnabled(result.multifactorEnabled);
                    if (result.multifactorRetryCount == 0) { //verified will reset the retry to 0
                        this._userService.completeAuthentication(result.accessToken, result.accessTokenExpiresAtUtc);
                        this._verifyService.setLastVerifiedOTP(result.lastVerifiedOTP);
                        this._verifyService.setLastVerifiedIpAddress(result.lastVerifiedIpAddress);
                        this._verifyService.setCurrentIPAddress(result.lastVerifiedIpAddress);
                        if (!this.logonUserInformation.securityQuestionSetupFlag) {
                            this._router.navigate(['securityquestion']);
                            return;
                        }
                        //01/19/2026 RA - Check if user needs to be routed to Profile page to update invalid user information.
                        if ((diffDays2 < this.logonUserInformation.daysLastLogin) && (this.logonUserInformation.createdDateMin < todayMin) &&
                            (this.logonUserInformation.invalidAddr === 'N') &&
                            (this.logonUserInformation.invalidPhone === 'N') && (this.logonUserInformation.invalidEmail === 'N')) {
                          this._router.navigate(['']);                      //01/19/2026 RA - Route user to the home page.
                        }
                        else {
                              this._router.navigate(['profile']);           //01/19/2026 RA - Route user to the Profile page to check for valid user information.
                        }
                    } else if (result.multifactorRetryCount > 0) {
                        if (result.multifactorRetryCount === 5) { //max count, disabled account

                            this._userService.logout();
                            this._router.navigate(['login'])

                        }
                        this.showTemporaryPasswordError = true; //below retry, show error
                    } else if (result.temporaryPasswordExpiredFlag !== null && result.temporaryPasswordExpiredFlag) {
                        this.showExpiredVerificationCodeError = true;
                    }
                }
                else { //return was empty

                    this._userService.logout();

                    this._router.navigate(['register']);
                }
            },
            error => {
                this._handleError('MultifactorVerifyComponent.checkVerificationCode', error);
            }
        );
    }

    enroll(): void {
        this.sendVerificationCode(false);
        this.setView(true)
    }

    sendVerificationCode(resendFlag:boolean): void {
        if (this._logging.navigationTraceLog) {
            console.log('MultifactorComponent.sendVerifyCode');
        }

        this.showActivitySpinner = true;

        this._verifyService.sendVerificationCode(resendFlag).subscribe(
            result => {
                if (this._logging.serviceCallTraceLog) {
                    console.log('MultifactorVerifyComponent.sendVerifyCode :: result2 = ' + result);
                }
                if (this._logging.serviceDataTraceLog) {
                    console.log('MultifactorVerifyComponent.sendVerifyCode :: result2 = ' + result);
                }

                this.showActivitySpinner = false;

            },
            error => {
                this._handleError('MultifactorVerifyComponent.sendVerifyCode', error);
            }
        );
    }

    scrollToTop() {
        const contentStart = document.getElementsByClassName('mat-sidenav-content');
        if (contentStart.length > 0) {
            contentStart[0].scrollTop = 0;
        }
    }

    formatPhoneNumber(phoneNumber: string): string {
        return phoneNumber !== null && phoneNumber.length > 7
          ? phoneNumber.substr(0, 3) + '.' + phoneNumber.substr(3, 3) + '.' + phoneNumber.substr(6)
          : '';
      }
}
